import React from "react"
import theme from "./../../../Theme/Theme"
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const Item = styled(NavLink)`
  padding: 0px 15px !important;
  border-bottom: ${props => props.active === "true" ? `2px solid ${theme.colors.primary}` : null};
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${theme.colors.dark};
`;

function Tab(props) {
  const title = '/' + props.title;
  return (
    <Item
      className={'tab'}
      active={props.active ? "true" : "false"}
      to={ props.title === 'overview' ? '/' :  title }
      onClick={props.action}
    >
      {props.title.charAt(0).toUpperCase() + props.title.slice(1)}
    </Item>
  )
}



export default Tab
